import { DataSource } from '@angular/cdk/collections';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';

import { DocumentCreatorService } from '../document-creator.service';

export class DocumentsDataSource extends DataSource<any> {
  data: any[];
  paginator: MatPaginator;
  sort: MatSort;
  nonFilteredData: any;
  /**
   *
   */
  constructor(data: any) {
    super();
    this.data = data;
  }
  connect(): Observable<any[]> {
    // Combine everything that affects the rendered data into one update
    // stream for the data-table to consume.
    const dataMutations = [
      observableOf(this.data),
      this.paginator.page,
      this.sort.sortChange
    ];

    return merge(...dataMutations).pipe(map(() => {
      return this.getPagedData(this.getSortedData([...this.data]));
    }));
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() { }

  // filter(field, fullData) {

  //     let filterApplied = false;
  //     let filterData: any[];
  //     if (field['epicorIdFilter']) {
  //         console.log(field['epicorIdFilter']);
  //         filterApplied = true;
  //         filterData = this.nonFilteredData.filter(bp => {
  //             return bp.externalCustomerId.toLocaleLowerCase().indexOf(field['epicorIdFilter'].toLocaleLowerCase()) > -1;
  //         });
  //         console.log(this.data.length);
  //         console.log(this.nonFilteredData.length);
  //     }
  //     if (field['commonNameFilter']) {
  //         filterApplied = true;
  //         filterData = this.nonFilteredData.filter(bp => {
  //             return bp.commonName.toLocaleLowerCase().indexOf(field['commonNameFilter'].toLocaleLowerCase()) > -1;
  //         });
  //     }
  //     if (field['legalNameFilter']) {
  //         filterApplied = true;
  //         filterData = this.nonFilteredData.filter(bp => {
  //             return bp.legalName.toLocaleLowerCase().indexOf(field['legalNameFilter'].toLocaleLowerCase()) > -1;
  //         });
  //     }
  //     if (!filterApplied) {
  //         filterData = fullData;
  //     }
  //     return filterData;
  // }

  /**
   * Paginate the data (client-side). If you're using server-side pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: any[]) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    return data.splice(startIndex, this.paginator.pageSize);
  }

  /**
   * Sort the data (client-side). If you're using server-side sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: any[]) {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'title': return compare(a.title, b.title, isAsc);
        case 'description': return compare(a.description, b.description, isAsc);
        case 'module': return compare(a.module, b.module, isAsc);
        default: return 0;
      }
    });
  }

}

/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a: string | number, b: string | number, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
